// extracted by mini-css-extract-plugin
module.exports = {"video-link":"h_F d-flex align-items-center my-2","video-link__link":"h_G ml-2"};